import apiClient from "../api/axios";
import { handleApiError } from "../api/handleApiError";
import { SubOrganizations } from "../models/SubOrganization";
import { Organization, TierPlan } from "../models/Organization";
import { AxiosResponse } from "axios";
import {
  OrganizationRetrievalResponseDto,
  TierPlanRetrievalResponseDto,
} from "../models/dto/response/organization-response.model";
import { ApiRequestConfig } from "../models/api-responses.types";

const OrganizationService = {
  getOrganization: async (): Promise<Organization | null> => {
    try {
      const response: AxiosResponse<OrganizationRetrievalResponseDto> =
        await apiClient.get("/v1/organizations");

      return response.data.results.organization;
    } catch (error) {
      handleError(error);
    }

    return null;
  },
  getSubOrganizationList: async (): Promise<SubOrganizations[]> => {
    try {
      const response = await apiClient.get("/v1/suborganizations");

      if (response.status === 200) {
        const result: SubOrganizations[] =
          response.data.results.suborganizations;

        return result;
      }
    } catch (error: any) {
      handleError(error);
    }

    return [];
  },
  updateOrganizations: async (
    name: string,
    taxId: string,
    businessType: string,
    orgProfile: string,
  ): Promise<Organization | null> => {
    try {
      const body: Object = {
        name: name,
        taxId: taxId,
        businessType: businessType,
        orgProfile: orgProfile,
      };

      const response = await apiClient.patch("/v1/organizations", body);

      return response.data.results.organization;
    } catch (error: any) {
      handleError(error);
    }
    return null;
  },

  // No alert on failure: callers treat a missing plan as no limit, and the backend still enforces it.
  getTierPlan: async (): Promise<TierPlan | null> => {
    const config: ApiRequestConfig = { _suppressGlobalAlert: true };
    try {
      const response: AxiosResponse<TierPlanRetrievalResponseDto> =
        await apiClient.get("/v2/organizations/tier-plan", config);
      return response.data.results;
    } catch {
      return null;
    }
  },

  getOrganizationV2: async (): Promise<Organization | null> => {
    try {
      const response: AxiosResponse<OrganizationRetrievalResponseDto> =
        await apiClient.get("/v2/organizations");
      return response.data.results.organization;
    } catch (error) {
      handleError(error);
    }
    return null;
  },
  updateOrganizationsV2: async (
    name: string,
    nameEn: string,
    nameTh: string,
    taxId: string,
    businessTypeEn: string,
    businessTypeTh: string,
    orgProfile: string,
  ): Promise<Organization | null> => {
    try {
      const body: Object = {
        name: name,
        nameEn: nameEn,
        nameTh: nameTh,
        taxId: taxId,
        businessType: businessTypeEn,
        businessTypeEn: businessTypeEn,
        businessTypeTh: businessTypeTh,
        orgProfile: orgProfile,
      };
      const response: AxiosResponse<OrganizationRetrievalResponseDto> =
        await apiClient.patch(`/v2/organizations`, body);
      return response.data.results.organization;
    } catch (error) {
      handleError(error);
    }
    return null;
  },
};

const handleError = (error: unknown) =>
  handleApiError(
    error,
    {},
    { messageKey: "error-get-sub-organization", titleKey: "Error-Message" },
  );

export default OrganizationService;
